import { Injectable } from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {first, Subject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  constructor(private readonly confirmationService: ConfirmationService) { }

  public openYesNoModal(message: string, header: string, key: string |undefined = undefined) {
    const confirmation = new Subject<'yes' | 'no'>();
    this.confirmationService.confirm({
      message: message,
      header: header,
      closable: true,
      closeOnEscape: true,
      key: key,
      rejectButtonProps: {
        label: 'No',
        severity: 'secondary',
        outlined: true,
        size: 'small',
      },
      acceptButtonProps: {
        label: 'Yes',
        size: 'small',
      },
      reject: () => {
        confirmation.next('no')
      },
      accept: () => {
        confirmation.next('yes')
      }
    });

    return confirmation.pipe(first());
  }
}
